import { render, staticRenderFns } from "./VehiculoList.vue?vue&type=template&id=015558fe"
import script from "./VehiculoList.vue?vue&type=script&lang=ts"
export * from "./VehiculoList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports